(function () {
  "use strict";

  angular
    .module("alk.marketing")
    .controller("landingController", landingController);

  landingController.$inject = ["$rootScope", "$scope", "$http", "Messages", "$injector"];
  function landingController($rootScope, $scope, $http, Messages, $injector) {

    var vm = this;
    vm.formTab = "login";
    vm.isProcessing = false;

    $rootScope.$on("forgotPassword",function(msg) {
      vm.formTab = "forgot";
    });

    $scope.$watch("vm.formTab", function(newValue, oldValue){
      if (newValue !== oldValue) {
        Messages.clear();
      }
    });
  }
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-marketing/landing.controller.js